import { memo } from "react";
import TimePickerInput from "./time-picker-input";
import Selectbox from "components/shared/inputs/selectbox";
import { CSSTransition } from "react-transition-group";

const weekDays = [
    "شنبه",
    "یکشنبه",
    "دوشنبه",
    "سه شنبه",
    "چهارشنبه",
    "پنج شنبه",
    "جمعه"
];

const TimeList = props => {
    const { data, setData, activeTab, setActiveTab } = props;

    const addTime = () => {
        setData(prev => {
            const timesLength = prev.length;
            const id = timesLength ? prev[timesLength - 1].id + 1 : 1;

            return [
                ...prev,
                {
                    id,
                    day: activeTab,
                    start: null,
                    end: null,
                    status_id: 1
                }
            ]
        });
    }

    const changeHandler = (id, newVal) => {
        setData(prev => {
            const newState = [...prev];
            const index = newState.findIndex(time => time.id === id);

            newState[index] = {
                ...newState[index],
                ...newVal,
                error: false
            };

            return newState;
        });
    }

    const removeHandler = id => {
        setData(prev => {
            const newState = prev.filter(time => time.id !== id);
            return newState;
        });
    }

    const activeTabTimes = data.filter(time => time.day === activeTab);
    return (
        <div className="overflow-auto py-4">
            <div className=" timing-box min-w-[500px]">
                <div className="grid grid-cols-7 gap-3">
                    {
                        weekDays.map((weekDay, i) => {
                            let thisChilds = data.find(time => time.day === i);

                            return (
                                <div
                                    key={`week-day-${i}`}
                                    className={`day${i === activeTab ? " active" : ""}${thisChilds ? " has-child" : ""}`}
                                    onClick={() => setActiveTab(i)}
                                >
                                    <span>{weekDay}</span>
                                </div>
                            )
                        })
                    }
                </div>

                {
                    activeTabTimes.length > 0 && (
                        <div className="mt-8 pb-6">
                            {
                                activeTabTimes.map(time => (
                                    <div className="time" key={`${activeTab}-${time}-${time.id}`}>
                                        <CSSTransition
                                            in={time.error}
                                            appear={true}
                                            timeout={500}
                                            unmountOnExit={true}
                                        >
                                            <div className="error-fadebox pos-cover"></div>
                                        </CSSTransition>

                                        <div className="grid grid-cols-10 gap-2 relative">
                                            <div className="col-span-4">
                                                <TimePickerInput
                                                    label="شروع"
                                                    value={time.start}
                                                    changeHandler={val => changeHandler(time.id, { start: val })}
                                                />
                                            </div>

                                            <div className="col-span-4">
                                                <TimePickerInput
                                                    label="پایان"
                                                    value={time.end}
                                                    changeHandler={val => changeHandler(time.id, { end: val })}
                                                />
                                            </div>

                                            <div>
                                                <Selectbox
                                                    className="c1 tp-31 child-c1 oc tp-31"
                                                    placeholder={time.status_id ? "باز" : "بسته"}
                                                    options={[
                                                        { title: "باز", clickHandler: () => changeHandler(time.id, { status_id: 1 }) },
                                                        { title: "بسته", clickHandler: () => changeHandler(time.id, { status_id: 0 }) },
                                                    ]}
                                                />
                                            </div>

                                            <div>
                                                <button
                                                    className="bg-red-400 hover:bg-red-500 text-white text-sm block h-full w-full rounded-full transition-colors"
                                                    onClick={() => removeHandler(time.id)}
                                                >
                                                    حذف
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )
                }

                <button
                    className="bg-primary-100 text-white py-3 text-center block w-full rounded-lg text-sm mt-4 hover:bg-primary-200 transition-colors"
                    onClick={addTime}
                >
                    افزودن بازه زمانی جدید
                </button>
            </div>
        </div>
    )
}

export default memo(TimeList);